import { urlServices } from "./param-url.constants";

export const urlServiceHospitalInfra = {
    //orgs/{username}
    catalogOrgs: urlServices.urlServiceHospitalInfra + 'users/orgs/',
    //branches/{userId}/{orgId}
    catalogBranches: urlServices.urlServiceHospitalInfra + 'users/branches/',
    //profiles/{userId}/{branchId}
    catalogProfiles: urlServices.urlServiceHospitalInfra + 'users/profiles/',
    //{username}/workplaces
    catalogUserInfo: urlServices.urlServiceHospitalInfra + 'users/{username}/workplaces',
    //api/hospitals-infrastructures/users/forms/{languageCve}/{organizationId}
    catalogUserForms: urlServices.urlServiceHospitalInfra + 'users/forms/{languageCve}/{organizationId}',
    //api/hospitals-infrastructures/users/forms/translations
    formLabelTraduction: urlServices.urlServiceHospitalInfra + 'users/forms/translations',
    ///holidays/{branchOfficeId}
    catalogHolidayDays: urlServices.urlServiceHospitalInfra + 'holidays/{branchOfficeId}',
    ///holidays/find-by-filters
    catalogHolidayDaysByFilters: urlServices.urlServiceHospitalInfra + 'holidays/find-by-filters',
    ///holidays/save-holidays
    saveHolidayDays: urlServices.urlServiceHospitalInfra + 'holidays/save-holidays',
    ///holidays/update-holidays
    updateHolidayDays: urlServices.urlServiceHospitalInfra + 'holidays/update-holidays',
    ///holidays/delete-holidays
    deleteHolidayDays: urlServices.urlServiceHospitalInfra + 'holidays/delete-holidays/{holidayDayId}',
    ///holidays/lock-types-alls
    catalogLockTypes: urlServices.urlServiceHospitalInfra + 'holidays/lock-types-alls',
    //api/hospitals-infrastructures/forms/all/{branchId}
    catalogForms: urlServices.urlServiceHospitalInfra + 'forms/all/',

    profile: {
        //api/hospitals-infrastructures/profiles/{idProfile}
        one: urlServices.urlServiceHospitalInfra + 'profiles/',
        //api/hospitals-infrastructures/profiles/branch-offices/{branchId}
        list: urlServices.urlServiceHospitalInfra + 'profiles/branch-offices/',
        //api/hospitals-infrastructures/profiles
        new: urlServices.urlServiceHospitalInfra + 'profiles',
        //api/hospitals-infrastructures/profiles
        edit: urlServices.urlServiceHospitalInfra + 'profiles',
        //api/users-administrations/profiles/branch-offices/{branchOfficeId}
        search: urlServices.urlServiceHospitalInfra + 'profiles/branch-offices/',
        //api/hospitals-infrastructures/profiles/{idProfile}
        delete: urlServices.urlServiceHospitalInfra + 'profiles/'
    },
    screen: {
        //api/hospitals-infrastructures/forms/{formId}
        one: urlServices.urlServiceHospitalInfra + 'forms/',
        //api/hospitals-infrastructures/forms/branch-office/{branchOfficeId}
        list: urlServices.urlServiceHospitalInfra + 'forms/branch-office/',
        //api/hospitals-infrastructures/forms/{formId}
        edit: urlServices.urlServiceHospitalInfra + 'forms/',
        //api/hospitals-infrastructures/forms/branch-office/{branchOfficeId}/filter
        search: urlServices.urlServiceHospitalInfra + 'forms/branch-office/{branchOfficeId}/filter',
        //api/hospitals-infrastructures/forms/getFormTypes
        formTypes: urlServices.urlServiceHospitalInfra + 'forms/getFormTypes'
    },
    grants: {
        //api/hospitals-infrastructures/grants/add
        add: urlServices.urlServiceHospitalInfra + 'grants/add',
        //api/hospitals-infrastructures/grants/all
        all: urlServices.urlServiceHospitalInfra + 'grants/all',
        //api/hospitals-infrastructures/grants/branch-offices/{branchId}
        listByBranch: urlServices.urlServiceHospitalInfra + 'grants/branch-offices/',
        //api/hospitals-infrastructures/grants/branch-offices/{branchId}/paged/{page}/{size}
        listByIdGrant: urlServices.urlServiceHospitalInfra + 'grants/profiles/{grantId}/paged/{page}/{size}',
        //api/hospitals-infrastructures/grants/delete/{grantId}/{profileId}
        delete: urlServices.urlServiceHospitalInfra + 'grants/delete/',
        //api/hospitals-infrastructures/grants/profiles/{grantId}/paged/{page}/{size}
        listProfileByPage: urlServices.urlServiceHospitalInfra + 'grants/profiles/{grantId}/paged/{page}/',
        //api/hospitals-infrastructures/grants/search
        search: urlServices.urlServiceHospitalInfra + 'grants/search',
    },
    organization: {
        one: urlServices.urlServiceHospitalInfra + 'organization/',
        list: urlServices.urlServiceHospitalInfra + 'organization/list',
        new: urlServices.urlServiceHospitalInfra + 'organization/new',
        edit: urlServices.urlServiceHospitalInfra + 'organization/edit',
        search: urlServices.urlServiceHospitalInfra + 'organization/search',
    },
    branchoffice: {
        one: urlServices.urlServiceHospitalInfra + 'branch-office/',
    },

    catalogs: {
        one: urlServices.urlServiceHospitalInfra + 'catalogs_management',
        list: urlServices.urlServiceHospitalInfra + 'catalogs_management/{idBranchOffice}',
    },

    catalogsValues: {
        one: urlServices.urlServiceHospitalInfra + 'catalogs_management/values/{catalogManagementId}',
        add: urlServices.urlServiceHospitalInfra + 'catalogs_management/values',
        edit: urlServices.urlServiceHospitalInfra + 'catalogs_management/values',
        delete: urlServices.urlServiceHospitalInfra + 'catalogs_management/values/{catalogValueId}',
        byExternalId: urlServices.urlServiceHospitalInfra + 'catalogs_management/values/{branchOfficeId}/{externalId}',
        byExternalIdSystemCatalog: urlServices.urlServiceHospitalInfra + 'catalogs_management/values/system/{externalId}',
        update_catalogs: urlServices.urlServiceHospitalInfra + 'catalogs_management/update-catalogs/{branchOfficeId}',
    },

    clue: {
        one: urlServices.urlServiceHospitalInfra + 'clue/',
        autocomplete: urlServices.urlServiceHospitalInfra + 'clue/autocomplete/',
        filter: urlServices.urlServiceHospitalInfra + 'clue/filter',
        states: urlServices.urlServiceHospitalInfra + 'clue/states',
        bystate: urlServices.urlServiceHospitalInfra + 'clue/bystate/',
        details: urlServices.urlServiceHospitalInfra + 'clue/details/',
    },
    module:{
        moduleurl: urlServices.urlServiceHospitalInfra + 'units/getUnitTypes',
        formsUrl: urlServices.urlServiceHospitalInfra + 'forms/all/',
        saveModelUrl: urlServices.urlServiceHospitalInfra + 'units/saveUnit',
        searchUnitsUrl:urlServices.urlServiceHospitalInfra + 'units/getUnits',
        searchUnitsPageableUrl:urlServices.urlServiceHospitalInfra + 'units/getUnitsPageable',
        searchModuleUrl:urlServices.urlServiceHospitalInfra + 'units/getById',
        updateModelUrl:urlServices.urlServiceHospitalInfra + 'units/updateUnit',
        delete:urlServices.urlServiceHospitalInfra + 'units/delete/',

    },

}
